// Social Login Configuration
// REPLACE THE VALUES BELOW WITH YOUR ACTUAL CREDENTIALS

export const SOCIAL_LOGIN_CONFIG = {
  // PASTE YOUR GOOGLE CLIENT ID HERE (from Google Cloud Console)
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '162441173020-orahbghi22hpt6nuf3erbsrkkpaur6ei.apps.googleusercontent.com',
  
  // PASTE YOUR FACEBOOK APP ID HERE (from Facebook Developers)
  FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || '1431896438120744'
};

// ========================================
// SETUP INSTRUCTIONS:
// ========================================
//
// 1. GOOGLE SETUP:
//    - Go to: https://console.cloud.google.com/
//    - Create/Select your project
//    - Go to "APIs & Services" > "Library"
//    - Enable "Google+ API"
//    - Go to "APIs & Services" > "Credentials"
//    - Click "Create Credentials" > "OAuth 2.0 Client IDs"
//    - Application type: "Web application"
//    - Authorized JavaScript origins: http://localhost:3000
//    - Authorized redirect URIs: http://localhost:3000
//    - Copy the Client ID and replace the GOOGLE_CLIENT_ID above
//
// 2. FACEBOOK SETUP:
//    - Go to: https://developers.facebook.com/
//    - Create/Select your app
//    - Add "Facebook Login" product
//    - Go to "Facebook Login" > "Settings"
//    - App Domains: localhost
//    - Valid OAuth Redirect URIs: http://localhost:3000
//    - Copy the App ID from "Settings" > "Basic"
//    - Replace the FACEBOOK_APP_ID above
//
// 3. ENVIRONMENT VARIABLES (Optional but recommended):
//    - Create a file named ".env" in the frontend directory
//    - Add these lines:
//      REACT_APP_GOOGLE_CLIENT_ID=your_actual_google_client_id
//      REACT_APP_FACEBOOK_APP_ID=your_actual_facebook_app_id
//
// ======================================== 